'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _dateConstants = require('../../dateConstants');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale('zh-cn');

var reviseTimestamp = function reviseTimestamp(time, props) {
  var clearUnusedTimestamp = props.clearUnusedTimestamp,
      format = props.format;

  if (clearUnusedTimestamp) {
    switch (format) {
      case 'YYYY':
        time.month(0);
        time.date(1);
        time.hour(0);
        time.minute(0);
        break;
      case 'yyyy-MM':
        time.date(1);
        time.hour(0);
        time.minute(0);
        break;
      case 'yyyy-MM-dd':
        time.hour(0);
        time.minute(0);
        break;
      default:
        break;
    }
  }
  // 因为"年月日"和"年月日时分"两种格式都不需要毫秒和秒，所以置为0
  if (format !== 'yyyy-MM-dd HH:mm:ss') {
    time.second(0);
  }
  time.millisecond(0);
  return time.valueOf();
};

function timeStampNeedConvert(timestamp) {
  var useChinaDST = new Date(1990, 7, 1).getTimezoneOffset() === -540;
  var year = new Date(timestamp).getFullYear();
  var isDST = year > 1985 && year < 1992;
  return !useChinaDST && isDST;
}

function convertTimezoneOffset(value) {
  var isFormatIn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timestamp = +value;
  var needConvert = timeStampNeedConvert(timestamp);
  var offset = 60 * 60 * 1000;
  if (needConvert) {
    if (isFormatIn) {
      return timestamp + offset;
    } else {
      return timestamp - offset;
    }
  }
  return timestamp;
}

function formatIn(value) {
  if ((0, _lodash.isNil)(value)) {
    return null;
  } else if (_moment2.default.isMoment(value)) {
    return value;
  } else {
    return (0, _moment2.default)(convertTimezoneOffset(value));
  }
}

function formatOut(value, props) {
  var momentValue = void 0;
  if ((0, _lodash.isNil)(value)) {
    return null;
  } else if (_moment2.default.isMoment(value)) {
    momentValue = value;
  } else {
    momentValue = (0, _moment2.default)(value);
  }
  return reviseTimestamp(momentValue, props);
}

function defaultValueFormatter(value, $state) {
  var _getProps = (0, _utils.getProps)($state),
      dateType = _getProps.dateType,
      format = _getProps.format,
      readonly = _getProps.readonly;

  var realFormat = _dateConstants.TRANSFORM_FORMAT[format || dateType] || 'YYYY-MM-DD';
  if (readonly || $state.showReadonlyValue) {
    realFormat = _dateConstants.ORIGIN_TRANSFORM_FORMAT[format || dateType] || 'YYYY-MM-DD';
  }
  if (!(0, _lodash.isNil)(value)) {
    return value ? (0, _moment2.default)(convertTimezoneOffset(value)).format(realFormat) : value;
  }
  return value;
}

exports.default = {
  formatIn: formatIn,
  formatOut: formatOut,
  defaultValueFormatter: defaultValueFormatter
};
module.exports = exports['default'];